import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import WelcomePopup from "./components/WelcomePopup";

// Pages
import Home from "./pages/Home";
import NewsletterLibrary from "./pages/NewsletterLibrary";
import NewsletterDetail from "./pages/NewsletterDetail";
import QuickReads from "./pages/QuickReads";
import QuickReadDetail from "./pages/QuickReadDetail";
import VideoLibrary from "./pages/VideoLibrary";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/newsletters" element={<NewsletterLibrary />} />
            <Route path="/newsletter/:id" element={<NewsletterDetail />} />
            <Route path="/quick-reads" element={<QuickReads />} />
            <Route path="/quick-read/:id" element={<QuickReadDetail />} />
            <Route path="/videos" element={<VideoLibrary />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
        <WelcomePopup />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
